import store from '@/store'

let conf

function redirect(target) {
  const { token } = store.state.auth
  window.open(`${conf.api.baseURL}/${target}?token=${token}`)
}

const linkHelper = {
  redirect,
}

export default {

  install(Vue, config) {
    conf = config
    Vue.prototype.$linkHelper = linkHelper
  }

}
